import { render, staticRenderFns } from "./live.vue?vue&type=template&id=636d49aa&scoped=true&"
import script from "./live.vue?vue&type=script&lang=js&"
export * from "./live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d49aa",
  null
  
)

export default component.exports